import apiClient from '@/services/axios';

export async function create(data) {
  const response = await apiClient.post('/recurringNotifications/', data);
  if (response) {
    return response.data;
  }
  throw new Error('Unable to create recurring notification.');
}
